import { useState } from "react";

export default (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log("🚀 ~ file: localStorage.js:12 ~ const[storedValue,setStoredValue]=useState ~ error", error)
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
    console.log("🚀 ~ file: localStorage.js:26 ~ setValue ~ error", error)
    }
  };
  return [storedValue, setValue];
};
